export default class AppointmentStatus {
	constructor(public readonly id: string, public readonly value: string, public readonly label: string) {}

	static getStatuses(): AppointmentStatus[] {
		return [
			new AppointmentStatus(AppointmentStatusEnum.Confirmed, AppointmentStatusEnum.Confirmed, "Confirmed"),
			new AppointmentStatus(AppointmentStatusEnum.Unconfirmed, AppointmentStatusEnum.Unconfirmed, "Unconfirmed"),
			new AppointmentStatus(AppointmentStatusEnum.Deleted, AppointmentStatusEnum.Deleted, "Deleted"),
		]
	}

	static getStatusesForAppointmentCreation(): AppointmentStatus[] {
		return [
			new AppointmentStatus(AppointmentStatusEnum.Confirmed, AppointmentStatusEnum.Confirmed, "Confirmed"),
			new AppointmentStatus(AppointmentStatusEnum.Unconfirmed, AppointmentStatusEnum.Unconfirmed, "Unconfirmed")
		]
	};

	static fromString(value: string) {
		return AppointmentStatus.getStatuses().filter(s => s.value == value)[0];
	}
}

export enum AppointmentStatusEnum {
	Confirmed = "CONFIRMED",
	Unconfirmed = "UNCONFIRMED",
	Deleted = "DELETED"
}